import { shareColumnsExtend, shareFormColumnsExtend } from './share';
export const PRODUCT_CATEGORY_KINDS = [
  'other',
  'customized',
]

const entityColumns = {
  id: {
    model_name: 'ProductCategory',
    column_type: 'id',
    label_key_path: 'productCategory.id',
  },
  created_at: {
    model_name: 'ProductCategory',
    column_type: 'datetime',
    label_key_path: 'productCategory.createdAt',
  },
  updated_at: {
    model_name: 'ProductCategory',
    column_type: 'datetime',
    label_key_path: 'productCategory.updatedAt',
  },
  name: {
    model_name: 'ProductCategory',
    column_type: 'string',
    label_key_path: 'productCategory.name',
  },
  include_accessory: {
    model_name: 'ProductCategory',
    column_type: 'boolean',
    label_key_path: 'productCategory.includeAccessory',
  },
  skip_inbound: {
    model_name: 'ProductCategory',
    column_type: 'boolean',
    label_key_path: 'productCategory.skipInbound',
  },
  kind: {
    model_name: 'ProductCategory',
    column_type: 'enum',
    extra: {
      options: ['other', 'customized'],
    },
    label_key_path: 'productCategory.kind',
  },
}

export const columnsExtend = (columns) => {
  return shareColumnsExtend(entityColumns, columns)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(entityColumns, columns, { formColumnsConfig, type, data })
}
